<template>
  <div class="padres-container">

    <!-- RASGADO SUPERIOR -->
    <div class="rasgado rasgado-superior"></div>

    <!-- Overlay para legibilidad -->
    <div class="overlay-rosado"></div>

    <!-- CONTADOR -->
    <div ref="contadorRef" class="contador-container">

      <br><br>
      <div class="frase-container">
        <h2 ref="fraseLinea1" class="frase linea1">¡Cada segundo</h2>
        <h2 ref="fraseLinea2" class="frase linea2">más cerca</h2>
        <p ref="fraseLinea3" class="frase linea3">de mi gran día!</p>
      </div>

      <div class="contador-titulo">
        <span ref="soloRef" class="solo">Solo</span>
        <span ref="faltanRef" class="faltan">Faltan</span>
      </div>

      <div ref="flechaRef" class="flecha-wrapper">
        <img src="@/assets/15.avif" alt="Flecha decorativa" class="flecha-img" />
      </div>

      <div class="contador-numeros">
        <div ref="tiempoRef1" class="tiempo">
          <span class="numero">{{ dias }}</span>
          <span class="etiqueta">Días</span>
        </div>
        <div ref="tiempoRef2" class="tiempo">
          <span class="numero">{{ horas }}</span>
          <span class="etiqueta">Horas</span>
        </div>
        <div ref="tiempoRef3" class="tiempo">
          <span class="numero">{{ minutos }}</span>
          <span class="etiqueta">Minutos</span>
        </div>
        <div ref="tiempoRef4" class="tiempo">
          <span class="numero">{{ segundos }}</span>
          <span class="etiqueta">Segundos</span>
        </div>

        <div class="rasgado rasgado-inferior"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import gsap from 'gsap'

export default {
  name: 'BienvenidaPadresPage',
  setup() {
    const contadorRef = ref(null)
    const soloRef = ref(null)
    const faltanRef = ref(null)
    const flechaRef = ref(null)
    const tiempoRef1 = ref(null)
    const tiempoRef2 = ref(null)
    const tiempoRef3 = ref(null)
    const tiempoRef4 = ref(null)

    const dias = ref('00')
    const horas = ref('00')
    const minutos = ref('00')
    const segundos = ref('00')

    let timerId = null

    const cuentaAtras = () => {
      const evento = new Date('2026-10-10T16:00:00')
      const tick = () => {
        const ahora = new Date()
        const diferencia = evento - ahora
        if (diferencia <= 0) {
          dias.value = horas.value = minutos.value = segundos.value = '00'
          clearInterval(timerId)
          return
        }
        dias.value = String(Math.floor(diferencia / (1000 * 60 * 60 * 24))).padStart(2, '0')
        horas.value = String(Math.floor((diferencia / (1000 * 60 * 60)) % 24)).padStart(2, '0')
        minutos.value = String(Math.floor((diferencia / (1000 * 60)) % 60)).padStart(2, '0')
        segundos.value = String(Math.floor((diferencia / 1000) % 60)).padStart(2, '0')
      }
      tick()
      timerId = setInterval(tick, 1000)
    }

    onMounted(async () => {
      await nextTick()
      cuentaAtras()

      // ESTADO INICIAL
      gsap.set(contadorRef.value, { autoAlpha: 0, y: -80 })
      gsap.set([soloRef.value, faltanRef.value], { autoAlpha: 0, y: -40 })
      gsap.set(flechaRef.value, { autoAlpha: 0, y: -30, scale: 0.85 })
      gsap.set(
        [tiempoRef1.value, tiempoRef2.value, tiempoRef3.value, tiempoRef4.value],
        { autoAlpha: 0, y: -30 }
      )

      const el = contadorRef.value

      const io = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return

          const tl = gsap.timeline({ defaults: { ease: 'power2.out' } })

          // Panel
          tl.to(el, {
            autoAlpha: 1,
            y: 0,
            duration: 0.9,
            ease: 'back.out(1.4)'
          })

          // Título
          tl.to(soloRef.value, {
            autoAlpha: 1,
            y: 0,
            duration: 0.6
          }, '>-0.3')

          tl.to(faltanRef.value, {
            autoAlpha: 1,
            y: 0,
            duration: 0.6
          }, '>-0.45')

          // Flecha
          tl.to(flechaRef.value, {
            autoAlpha: 1,
            y: 0,
            scale: 1,
            duration: 0.8,
            ease: 'back.out(1.6)'
          }, '>-0.2')

          // Contador
          tl.to(
            [tiempoRef1.value, tiempoRef2.value, tiempoRef3.value, tiempoRef4.value],
            {
              autoAlpha: 1,
              y: 0,
              duration: 0.5,
              stagger: 0.12
            },
            '>-0.1'
          )

          // Animaciones vivas
          gsap.to(el, {
            scale: 1.01,
            duration: 3,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut'
          })

          gsap.to(flechaRef.value, {
            y: '+=6',
            duration: 2,
            repeat: -1,
            yoyo: true,
            ease: 'sine.inOut',
            delay: 0.5
          })

          io.disconnect()
        })
      }, { threshold: 0.35 })

      if (el) io.observe(el)
    })

    onUnmounted(() => {
      if (timerId) clearInterval(timerId)
    })

    return {
      contadorRef,
      soloRef,
      faltanRef,
      flechaRef,
      tiempoRef1,
      tiempoRef2,
      tiempoRef3,
      tiempoRef4,
      dias,
      horas,
      minutos,
      segundos
    }
  }
}
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Cinzel:wght@600;700&family=Great+Vibes&family=Playfair+Display:ital,wght@0,600;1,500&family=Poppins:wght@400;600&display=swap');

/* =========================
   CONTENEDOR GENERAL
========================= */
.padres-container {
  position: relative;
  width: 100%;
  min-height: 40vh;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
  color: #312f2f !important;
}

/* =========================
   OVERLAY
========================= */
.overlay-rosado {
  position: absolute;
  inset: 0;
  z-index: 1;
}

/* =========================
   CONTENEDOR DEL CONTADOR
========================= */
.contador-container {
  position: relative;
  z-index: 2;
  width: 100%;
  max-width: 600px;
  padding: 26px 14px 34px;
  margin-top: 20px;
  text-align: center;
  background-color: #d8e9f3;
  color: #4979a0 !important;
  box-shadow: 0 12px 32px rgba(73, 121, 160, 0.15);
  border-radius: 8px;
  opacity: 0;
  transform: translateY(50px);
}

/* =========================
   FRASE SUPERIOR
========================= */
.frase {
  color: #4979a0 !important;
  -webkit-text-fill-color: #4979a0 !important;
  opacity: 1 !important;
  text-shadow: none !important;
  mix-blend-mode: normal !important;
  filter: none !important;
}

.frase.linea1,
.frase.linea2 {
  font-family: 'Cinzel', 'Playfair Display', serif;
  font-size: 26px;
  letter-spacing: 1px;
}

.frase.linea3 {
  font-family: 'Great Vibes', cursive, serif;
  font-size: 32px;
  color: #cba56b !important;
  -webkit-text-fill-color: #cba56b !important;
}

/* =========================
   TÍTULO SOLO / FALTAN
========================= */
.contador-titulo {
  margin-top: 10px;
  margin-bottom: 6px;
}

.contador-titulo .solo {
  font-family: 'Great Vibes', cursive, serif;
  font-size: 42px;
  display: block;
  color: #cba56b !important;
  -webkit-text-fill-color: #cba56b !important;
  opacity: 0;
}

.contador-titulo .faltan {
  font-family: 'Cinzel', 'Playfair Display', serif;
  font-size: 44px;
  font-weight: 700;
  letter-spacing: 2px;
  display: block;
  color: #4979a0 !important;
  -webkit-text-fill-color: #4979a0 !important;
  opacity: 0;
  text-transform: uppercase;
}

/* =========================
   FLECHA
========================= */
.flecha-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 50px;
  padding-top: 50px;
  margin: 4px 0 10px;
}

.flecha-img {
  width: 30px;
  height: auto;
  opacity: .95;
  filter: drop-shadow(0 1px 2px rgba(0,0,0,.18));
}

/* =========================
   CONTADOR NUMÉRICO
========================= */
.contador-numeros {
  display: flex;
  justify-content: space-around;
  gap: 10px;
  padding: 4px 8px 12px;
}

.tiempo {
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  transform: translateY(50px);
}

.numero {
  font-size: 40px;
  font-weight: bold;
  font-family: 'Cinzel', 'Playfair Display', serif;
  color: #4979a0 !important;
  -webkit-text-fill-color: #4979a0 !important;
}

.etiqueta {
  font-size: 14px;
  font-family: 'Poppins', sans-serif;
  margin-top: 5px;
  color: #cba56b !important;
  -webkit-text-fill-color: #cba56b !important;
  text-transform: uppercase;
  letter-spacing: 1px;
}

/* =========================
   RASGADOS
========================= */
.rasgado {
  position: absolute;
  left: 0;
  width: 100%;
  height: 50px;
  background-color: #f5f0e6;
  z-index: 3;
  pointer-events: none;
}

.rasgado-superior {
  top: 0;
  margin-top: 0;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  clip-path: polygon(
    0% 80%, 25% 60%, 50% 85%, 75% 55%, 100% 75%,
    100% 0%, 0% 0%
  );
}

.rasgado-inferior {
  bottom: 0; 
  margin-top: -40px;
  clip-path: polygon(
    0% 20%, 25% 40%, 50% 15%, 75% 45%, 100% 25%,
    100% 100%, 0% 100%
  );
}

/* =========================
   RESPONSIVE
========================= */
@media (max-width: 420px) {
  .contador-numeros { gap: 6px; }
  .numero { font-size: 34px; }
}

/* =========================
   FIX iOS (Safari)
========================= */
.frase,
.frase * {
  color: #4979a0 !important;
  -webkit-text-fill-color: #4979a0 !important;
  text-shadow: none !important;
  mix-blend-mode: normal !important;
}

.contador-titulo .solo {
  color: #cba56b !important;
  -webkit-text-fill-color: #cba56b !important;
}

.contador-titulo .faltan {
  color: #4979a0 !important;
  -webkit-text-fill-color: #4979a0 !important;
}

.numero {
  color: #4979a0 !important;
  -webkit-text-fill-color: #4979a0 !important;
}

.etiqueta {
  color: #cba56b !important;
  -webkit-text-fill-color: #cba56b !important;
}
</style>